// Add custom classes to the plugin provided section to be able to edit CSS

const shoppableImagesDel = document.querySelectorAll(".lookfy-section");
const sectionsDel = [];

shoppableImagesDel.forEach((shoppableImage) => {
  const parentSection =
    shoppableImage.parentElement.parentElement.parentElement;
  if (!sectionsDel.includes(parentSection)) {
    sectionsDel.push(parentSection);
  }
});

sectionsDel.forEach((element) => {
  element.classList.add("custom--shoppable-image-del");
  element.firstChild.classList.remove("page-width");
});

// Add custom features to our hostpot tooltip
const hotspotsDel = document.querySelectorAll(".kt-hotspot-item");

// TODO: Re position tooltip based on viewport relative position (currently not working, review it, not priority)
hotspotsDel.forEach((hotspot) => {
  let hoverTimeout;

  //   if (window.innerWidth < 800) return;

  const rePosition = () => {
    const hotspotId = hotspot.getAttribute("data-id");
    const tooltip = document.querySelector(
      `.kt-tooltip[data-id='${hotspotId}']`
    );
    // Clear the timeout if the user re-enters the hotspot before the tooltip is hidden
    clearTimeout(hoverTimeout);

    //Clear any existing styles if the clearTimeout is triggered before the removal

    // Get each tooltip position and viewport dimensions
    tooltip.style.transform = "";

    const hotspotPosition = hotspot.getBoundingClientRect();
    const tooltipPosition = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    if (hotspotPosition.left + tooltipPosition.width > viewportWidth) {
      tooltip.style.right = "20px";
      tooltip.style.left = "unset";
    }
    if (hotspotPosition.right - tooltipPosition.width < 0) {
      tooltip.style.left = "20px";
      tooltip.style.right = "unset";
    }
  };

  hotspot.addEventListener("mouseenter", () => rePosition());
  hotspot.addEventListener("touchstart", () => {
    setTimeout(() => rePosition(), 100);
  });
  hotspot.addEventListener("mouseleave", () => {
    const tooltip = document.querySelector(".kt-tooltip");
    // After the opacity transition, reset the transform
    hoverTimeout = setTimeout(() => {
      tooltip.style.transform = "";
    }, 200); // Match the duration of the opacity transition
  });
});

hotspotsDel.forEach((hotspot) => {
  const handleTooltipCreation = async () => {
    const hotspotId = hotspot.getAttribute("data-id");
    const tooltipParent = document.querySelector(
      `.kt-tooltip[data-id='${hotspotId}']`
    );
    const tooltip = tooltipParent.querySelector(".hotspot-item-detail");
    const tooltipDetail = tooltipParent.querySelector(
      ".hotspot-item-detail-inner"
    );

    if (!tooltip) return;

    // Fetch product data using the handle
    const handle = tooltip.getAttribute("data-handle");
    if (!handle) return;

    // Change image width to avoid pixelation
    const image = tooltip.querySelector("img");
    const prevSrc = tooltip.querySelector("img").src;
    const newSrc = prevSrc.replace("width=140", "width=200");
    image.src = newSrc;

    // Fetch product
    const product = await fetchProductDel(handle);

    // Add variant ID to href at image anchor
    const imageAnchor = tooltip.querySelector(".hotspot-item-image > a");
    imageAnchor.href = `/products/${product.handle}?variant=${product.variants[0].id}`;

    const priceElement = tooltipDetail.querySelector(".hotspot-item-price");
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(product.price / 100);
    priceElement.textContent = `${formattedPrice}`;

    const formSelector = `form[data-id='product-form-${product.id}']`;
    const formElement = tooltipDetail.querySelector(formSelector);

    // Check if the form exists
    const formExists = !!formElement;

    if (formExists) return;

    // Create the form element
    const form = formCreationDel(product);

    // Append the form to the new div
    const initialHeight = tooltipParent.offsetHeight;
    tooltipParent.style.height = "auto";
    tooltipDetail.append(form);
    const newHeight = tooltipParent.offsetHeight;
    // Reset the height to the initial height
    tooltipParent.style.height = `${initialHeight}px`;

    // Force a reflow to apply the initial height
    tooltipParent.offsetHeight; // This line is necessary to force a reflow

    // Set the height to the new height to trigger the transition
    tooltipParent.style.height = `${newHeight}px`;
  };

  hotspot.addEventListener("mouseenter", () => {
    setTimeout(handleTooltipCreation, 0);
  });
  hotspot.addEventListener("touchstart", () => {
    setTimeout(handleTooltipCreation, 200);
  });
});

function fetchProductDel(handle) {
  return fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .then((product) => {
      return product;
    })
    .catch((error) => {
      console.error("Error fetching product:", error);
    });
}

function formCreationDel(product) {
  // Create the form element
  const formElement = document.createElement("form");
  formElement.setAttribute("action", "/cart/add");
  formElement.setAttribute("method", "post");
  formElement.setAttribute("id", `product-form-${product.id}`);
  formElement.setAttribute("data-id", `product-form-${product.id}`);
  formElement.setAttribute("class", "form");
  formElement.setAttribute("novalidate", "novalidate");
  formElement.setAttribute("data-type", "add-to-cart-form");

  // Create the inner HTML using template strings
  let formInnerHTML = `
      <input type="hidden" name="id" value="" class="product-variant-id">
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="product-id" value="${product.id}">
      <input type="hidden" name="section-id" value="customId-${product.id}">
      <input type="hidden" name="quantity" value="1">
      <input type="hidden" name="sections" value="cart-notification-product,cart-notification-button,cart-icon-bubble">
      <input type="hidden" name="sections_url" value="${product.url}">
  
      <fieldset class="js product-form__input product-form__input--pill">
        <legend class="form__label">
          Color:
          <span data-selected-value="">${
            product.options.find((option) => option.name === "Color").values[0]
          }</span>
        </legend>
    `;

  // Function to check if a variant exists for the given options
  function variantExists(selectedOptions) {
    return product.variants.find((variant) =>
      selectedOptions.every((option) => variant.options.includes(option))
    ).available;
  }

  // Loop through the color options and render each input
  const colorOptions = product.options.find(
    (option) => option.name === "Color"
  );
  if (colorOptions) {
    colorOptions.values.forEach((color, index) => {
      const isChecked = index === 0 ? "checked" : ""; // Check the first option by default
      const uniqueId = `color-${product.id}-${index}`;
      const variant = product.variants.find((variant) =>
        variant.options.includes(color)
      );
      const isDisabled = !variantExists([color]);

      formInnerHTML += `
          <input type="radio" id="${uniqueId}-color-1-${index}" name="Color-1-${
        product.id
      }" value="${color}" form="product-form-${product.id}" ${isChecked} ${
        isDisabled ? "disabled" : ""
      } data-product-url="" data-option-value-id="${variant ? variant.id : ""}">
          <label for="${uniqueId}-color-1-${index}" title="${color}" class="swatch-input__label">
            ${color}
            <span class="visually-hidden label-unavailable">Variant sold out or unavailable</span>
          </label>
        `;
    });
  }

  formInnerHTML += `
      </fieldset>
  
      <fieldset class="js product-form__input product-form__input--pill">
        <legend class="form__label">Width</legend>
    `;

  // Loop through the width options and render each input
  const widthOptions = product.options.find(
    (option) => option.name === "Width"
  );
  if (widthOptions) {
    widthOptions.values.forEach((width, index) => {
      const isChecked = index === 0 ? "checked" : ""; // Check the first option by default
      const uniqueId = `width-${product.id}-${index}`;
      const variant = product.variants.find((variant) =>
        variant.options.includes(width)
      );
      const isDisabled = !variantExists([width]);

      formInnerHTML += `
          <input type="radio" id="${uniqueId}-width-3-${index}" name="Width-3-${
        product.id
      }" value="${width}" form="product-form-${product.id}" ${isChecked} ${
        isDisabled ? "disabled" : ""
      } data-product-url="" data-option-value-id="${variant ? variant.id : ""}">
          <label for="${uniqueId}-width-3-${index}">
            ${width}<span class="visually-hidden label-unavailable">Variant sold out or unavailable</span>
          </label>
        `;
    });
  }

  formInnerHTML += `
      </fieldset>
  
      <fieldset class="js product-form__input product-form__input--pill">
        <legend class="form__label">Shoe size</legend>
    `;

  // Loop through the shoe size options and render each input
  const shoeSizeOptions = product.options.find(
    (option) => option.name === "Size"
  );
  if (shoeSizeOptions) {
    shoeSizeOptions.values.forEach((size, index) => {
      const isChecked = index === 0 ? "checked" : ""; // Check the first option by default
      const uniqueId = `shoe-size-${product.id}-${index}`;
      const variant = product.variants.find((variant) =>
        variant.options.includes(size)
      );
      const isDisabled = !variantExists([size]);

      formInnerHTML += `
          <input type="radio" id="${uniqueId}-shoe-size-2-${index}" name="Size-2-${
        product.id
      }" value="${size}" form="product-form-${product.id}" ${isChecked} ${
        isDisabled ? "disabled" : ""
      } data-product-url="" data-option-value-id="${variant ? variant.id : ""}">
          <label for="${uniqueId}-shoe-size-2-${index}">
            ${size}<span class="visually-hidden label-unavailable">Variant sold out or unavailable</span>
          </label>
        `;
    });
  }

  formInnerHTML += `
      </fieldset>
  
      <div class="product-form__buttons">
        <button id="ProductSubmitButton-${product.id}" type="submit" name="add" class="product-form__submit button button--full-width button--secondary product-form__submit--custom">
          <span>Add to cart</span>
          <div class="loading__spinner hidden">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>
        <a href="${product.url}?variant=${product.variants[0].id}" class="product-form__submit button button--full-width button--secondary product-form__submit--custom"><span>Quickview</span></a>
      </div>
    `;

  // Set the inner HTML of the form element
  formElement.innerHTML = formInnerHTML;

  // Function to find the variant ID based on selected options
  function findVariantId() {
    const selectedColor = formElement.querySelector(
      `input[name="Color-1-${product.id}"]:checked`
    ).value;
    const selectedWidth = formElement.querySelector(
      `input[name="Width-3-${product.id}"]:checked`
    ).value;
    const selectedShoeSize = formElement.querySelector(
      `input[name="Size-2-${product.id}"]:checked`
    ).value;
    const variant = product.variants.find(
      (variant) =>
        variant.options.includes(selectedColor) &&
        variant.options.includes(selectedWidth) &&
        variant.options.includes(selectedShoeSize)
    );

    return variant ? variant.id : null;
  }

  // Function to update the availability of options
  function updateOptionAvailability() {
    const selectedColor = formElement.querySelector(
      `input[name="Color-1-${product.id}"]:checked`
    ).value;
    const selectedWidth = formElement.querySelector(
      `input[name="Width-3-${product.id}"]:checked`
    ).value;
    const selectedShoeSize = formElement.querySelector(
      `input[name="Size-2-${product.id}"]:checked`
    ).value;

    // Update width options
    widthOptions.values.forEach((width, index) => {
      const widthInput = formElement.querySelector(
        `input[id="width-${product.id}-${index}-width-3-${index}"]`
      );
      const isDisabled = !variantExists([
        selectedColor,
        width,
        selectedShoeSize,
      ]);
      widthInput.disabled = isDisabled;
    });

    // Update shoe size options
    shoeSizeOptions.values.forEach((size, index) => {
      const sizeInput = formElement.querySelector(
        `input[id="shoe-size-${product.id}-${index}-shoe-size-2-${index}"]`
      );
      const isDisabled = !variantExists([selectedColor, selectedWidth, size]);
      sizeInput.disabled = isDisabled;
    });

    // Update color options
    colorOptions.values.forEach((color, index) => {
      const colorInput = formElement.querySelector(
        `input[id="color-${product.id}-${index}-color-1-${index}"]`
      );
      const isDisabled = !variantExists([
        color,
        selectedWidth,
        selectedShoeSize,
      ]);
      colorInput.disabled = isDisabled;
    });

    const submitButton = formElement.querySelector(".product-form__submit");
    const isButtonDisabled = !variantExists([
      selectedColor,
      selectedWidth,
      selectedShoeSize,
    ]);
    submitButton.disabled = isButtonDisabled;
  }

  // Add event listeners to update the hidden input and form ID with the selected variant ID
  const colorRadioButtons = formElement.querySelectorAll(
    `input[name="Color-1-${product.id}"]`
  );
  const widthRadioButtons = formElement.querySelectorAll(
    `input[name="Width-3-${product.id}"]`
  );
  const shoeSizeRadioButtons = formElement.querySelectorAll(
    `input[name="Size-2-${product.id}"]`
  );
  const hiddenInput = formElement.querySelector('input[name="id"]');

  colorRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selectedVariantId = findVariantId();
      hiddenInput.value = selectedVariantId;
      formElement.setAttribute("id", `product-form-${selectedVariantId}`);
      updateOptionAvailability();
    });
  });

  widthRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selectedVariantId = findVariantId();
      hiddenInput.value = selectedVariantId;
      formElement.setAttribute("id", `product-form-${selectedVariantId}`);
      updateOptionAvailability();
    });
  });

  shoeSizeRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selectedVariantId = findVariantId();
      hiddenInput.value = selectedVariantId;
      formElement.setAttribute("id", `product-form-${selectedVariantId}`);
      updateOptionAvailability();
    });
  });

  // Set the initial value of the hidden input and form ID to the first variant ID
  const initialVariantId = findVariantId();
  hiddenInput.value = initialVariantId;
  formElement.setAttribute("id", `product-form-${initialVariantId}`);
  updateOptionAvailability();

  return formElement;
}
